var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loggedIn)?_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Expert")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/all"}},[_vm._v("All")])],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }